const l = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle cx="16" cy="16" r="16" />
        <path
            d="M8.8 9.6l5.387 7.241L9.123 22.8h2.193l3.897-4.58 3.39 4.558H23.2l-5.665-7.615 4.792-5.542h-2.193l-3.595 4.193-.004.005L13.396 9.6H8.8zm2.586 1.26l1.315-.022 7.962 10.63-1.316.02-7.961-10.629z"
            fill="currentColor" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=twitter.es.C4YSJm3G.js.map
